import { render } from "./DisplayVerticalBarChart.vue?vue&type=template&id=72f42216"
import script from "./DisplayVerticalBarChart.vue?vue&type=script&lang=js"
export * from "./DisplayVerticalBarChart.vue?vue&type=script&lang=js"

import "./DisplayVerticalBarChart.vue?vue&type=style&index=0&id=72f42216&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__